import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { PaymentVerificationGuard } from '../../payment/guards/payment-verification.guard';
import { ShimanoMiniCartComponent } from './mini-cart.component';

@NgModule({
  declarations: [ShimanoMiniCartComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatTooltipModule,
    UrlModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        // NavigationComponent: {
        //   component: MiniCartComponent,
        // },
        MiniCartComponent: {
          component: ShimanoMiniCartComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [PaymentVerificationGuard],
        },
      },
    } as CmsConfig),
    MatBadgeModule,
    SharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MiniCartModule {}
